<div class="dialog-main">
    <div class="dialog">
        <div class="mat-dialog-actions" mat-dialog-actions [align]="selectedAlign">
            <button mat-button mat-dialog-close><mat-icon>close</mat-icon></button>
        </div>
        <div class="contact-content">
            <h3>Új konzultációs idő hozzáadása</h3>
            <div class="contact-form">
                <form novalidate [formGroup]="consultationForm!">
                    <div class="field-container">
                        <div class="field">
                            <span>Konzultáció napja*</span>
                            <div class="data">
                                <input formControlName="day" id="day" class="form-control" type="text" required
                                    [(ngModel)]="doctorConsultingHour.day" />
                            </div>
                        </div>
                    </div>
                </form>
                @if (addConsultingHour) {
                <div class="field-container">
                    <div class="field">
                        <span>Konzultáció kezdete</span>
                        <div class="data">
                            <input #startTimeInput id="startTime" class="form-control" type="time" required
                                [ngModel]="startTime" (change)="onChangestartTime()" />
                        </div>
                    </div>
                </div>
                }
                @if (addConsultingHour) {
                <div class="field-container">
                    <div class="field">
                        <span>Konzultáció vége</span>
                        <div class="data">
                            <input #endTimeInput id="endTime" class="form-control" type="time" required
                                [ngModel]="endTime" (change)="onChangeEndTime()" />
                        </div>
                    </div>
                </div>
                }
                @if (!addConsultingHour) {
                <div class="field-container">
                    <div class="field">
                        <span>Konzultációs idő</span>
                        <div class="data">
                            <input placeholder="változó" disabled />
                        </div>
                    </div>
                </div>
                }
                @if (addConsultingHour) {
                <button [ngStyle]="{ cursor: 'pointer', 'margin-top': '16px' }" (click)="changeConsulting()">
                    A konzultációs idő változó
                </button>
                }
                @if (!addConsultingHour) {
                <button [ngStyle]="{ cursor: 'pointer', 'margin-top': '16px' }" (click)="changeConsulting()">
                    Konzultációs idő megadása
                </button>
                }
            </div>
            <div class="field-container" [ngStyle]="{ 'margin-top': '8px' }">
                <div class="field"
                    [ngStyle]="{ 'justify-content': 'center', 'margin-top': '8px', 'margin-bottom': '8px' }">
                    <div class="data" [ngStyle]="{ 'justify-content': 'center', width: '70%' }">
                        <button
                            [ngStyle]="{ background: '#eee', border: '1px solid #0E8388', 'font-weight': 'bold', width: '100%' }"
                            [disabled]="!consultationForm?.valid" (click)="addConsultation()">
                            KONZULTÁCIÓS IDŐ HOZZÁADÁSA
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>